import type { WorkoutTemplate } from '../../types';
import { Button } from '../ui/Button';
import { CARDS, TEXT } from '../../styles/classNames';

interface TemplateListProps {
  templates: WorkoutTemplate[];
  onEdit: (templateId: string) => void;
}

function formatDate(timestamp?: any) {
  try {
    return timestamp?.toDate?.()?.toLocaleString?.() || '';
  } catch {
    return '';
  }
}

export function TemplateList({ templates, onEdit }: TemplateListProps) {
  return (
    <div className="space-y-2 flex-1 overflow-auto pr-1">
      {templates.length === 0 && (
        <p className={TEXT.small}>
          Nothing saved yet. Build your first template to use it in client plans.
        </p>
      )}
      {templates.map((template) => (
        <div
          key={template.id}
          className={`${CARDS.nested} flex items-center justify-between gap-3 cursor-pointer hover:border-primary-500/50 transition-colors`}
          onClick={() => onEdit(template.id)}
        >
          <div className="flex-1 min-w-0">
            <p className={TEXT.h3}>{template.name}</p>
            <p className={TEXT.muted}>
              {template.items.length} items
              {template.notes ? ` · ${template.notes}` : ''}
            </p>
            <p className="text-[11px] text-slate-500 dark:text-slate-600">
              Updated: {formatDate(template.updatedAt)}
            </p>
          </div>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onEdit(template.id);
            }}
            variant="secondary"
            size="sm"
          >
            Edit
          </Button>
        </div>
      ))}
    </div>
  );
}
